import { render, staticRenderFns } from "./CustomAutocompleteInput.vue?vue&type=template&id=8872f3f2&"
import script from "./CustomAutocompleteInput.vue?vue&type=script&lang=js&"
export * from "./CustomAutocompleteInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomAutocompleteInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports